import React, { useMemo } from 'react';
import { NuvoGrid } from '@nuvolo/nuux-core/components/NuvoGrid';
import type { RecordPreviewProps } from './RecordPreviewProps';
import Styles from './Styles';
import deepMapChildren from '#/common/utils/deepMapChildren';
import renderItems from './renderItems';
import mapFieldItems from './mapFieldItems';
import { useNavigate } from 'react-router-dom';

const RecordPreview = <T,>({
  record,
  title,
  fields = [],
  noBorder,
  noPadding,
  emptyValue = 'Unknown',
}: RecordPreviewProps<T>) => {
  const navigate = useNavigate();
  const fieldItems = useMemo(() => {
    const items = mapFieldItems(fields, record, navigate, emptyValue);
    const newItems = deepMapChildren(items, (item) => item);

    return newItems;
  }, [fields, record, navigate, emptyValue]);

  return (
    <Styles $noBorder={noBorder} $noPadding={noPadding}>
      {!!title && <div className="record-preview-title">{title}</div>}
      <NuvoGrid container wrap="wrap">
        {renderItems(fieldItems)}
      </NuvoGrid>
    </Styles>
  );
};

export default React.memo(RecordPreview);
